module.exports = __webpack_public_path__ + "img/logo02.1908f676.png";